import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '../../environments/environment';
import { APIResponse } from '../_types/api-responses.types';
import { CarMakers, VehiclesReponse } from '../_types/vehicle.type';

@Injectable({
  providedIn: 'root',
})
export class VehicleInfoService {
  insurancebaseURL: string;

  constructor(private httpClient: HttpClient) {
    this.insurancebaseURL = `${environment.apiUrl}api/insurance/v1/`;
  }

  getBrands() {
    return this.httpClient.get<APIResponse<CarMakers>>(
      `${this.insurancebaseURL}car/manufacturers`
    );
  }

  getModels(brandName: string, date?: Date) {
    return this.httpClient.get<APIResponse<VehiclesReponse>>(
      `${this.insurancebaseURL}car/models`,
      {
        params: {
          brandName,
          ...(date
            ? {
                month: date.getMonth().toString(),
                year: date.getFullYear().toString(),
              }
            : {}),
        },
      }
    );
  }

  getModelsByCertificateId(certificateId: string, date?: Date) {
    return this.httpClient.get<APIResponse<VehiclesReponse>>(
      `${this.insurancebaseURL}car/models/certificate`,
      {
        params: {
          certificateId,
          ...(date
            ? {
                month: date.getMonth().toString(),
                year: date.getFullYear().toString(),
              }
            : {}),
        },
      }
    );
  }

  getVehicleByAutoId(autoId: string, year: number) {
    return this.httpClient.get<APIResponse<VehiclesReponse>>(
      `${this.insurancebaseURL}car/details`,
      {
        params: {
          autoId,
          year,
        },
      }
    );
  }

  searchVehicleByLicensePlate(licensePlate: string, date?: Date) {
    return this.httpClient.get<APIResponse<VehiclesReponse>>(
      `${this.insurancebaseURL}car/models/license-plate`,
      {
        params: {
          licensePlate,
          ...(date
            ? {
                year: date.getFullYear().toString(),
              }
            : {}),
        },
      }
    );
  }
}
